import { FlexAligner, StatusCard, Text, Button, Icon } from "src/components";
import { useTranslation } from "react-i18next";
import { TRANSLATION } from "src/models/constants";
import styling from "./NotFoundPage.module.scss";

export const NotFoundPage = () => {
	const { t } = useTranslation([TRANSLATION.COMMON]);

	return (
		<FlexAligner width="viewport" height="viewport" alignment="center" className={styling["wrapper"]}>
			<FlexAligner direction="column" alignment="center" className={styling["image"]}>
				<StatusCard
					color="warning"
					icon={<Icon name="LargeWarning" />}
					title={t("COMMON:notFound.title")}
					description={t("COMMON:notFound.message")}
					className={styling["card"]}
					childrenWithin={
						<FlexAligner direction="column" alignment="top-left" spacing="large" width="stretch">
							<Text weight="semi-bold" color="secondary">
								{t("COMMON:notFound.navDescription")}
							</Text>
							<FlexAligner tag="nav" direction={"row"} alignment="center-left" spacebetween width="stretch" spacing={"large"}>
								<FlexAligner direction="row" alignment="center-left" spacing={"large"} width="auto" tag="nav">
									<Button color={"neutral"} variant={"soft"}>
										{t("COMMON:notFound.emailText")}
									</Button>
									<Button color={"neutral"} variant={"soft"}>
										{t("COMMON:notFound.numberText")}
									</Button>
								</FlexAligner>
								<Button
									rightIcon={<Icon name="LargeHistoricalBrowser" />}
									variant={"solid"}
									onClick={() => {
										window.location.reload();
									}}
								>
									{t("COMMON:notFound.refreshText")}
								</Button>
							</FlexAligner>
						</FlexAligner>
					}
				/>
			</FlexAligner>
		</FlexAligner>
	);
};
